import { RowData } from "@tanstack/react-table"
import { Column, ReactTailwindTable, useTable } from "../../component/react-tailwind-table.tsx"
import { useGetOperatorCallTypeReportQuery } from "./service.ts"

const columns: Column<RowData>[] = [
  {
    accessorKey: "call_type",
    header: "Тип звонка",
    enableSorting: false,
  },
  {
    accessorKey: "total_score",
    header: "Общий балл",
    enableSorting: false,
  },
  {
    accessorKey: "evaluated_calls",
    header: "Оценено звонков",
    enableSorting: false,
  },
  {
    accessorKey: "total_duration",
    header: "Суммарная длительность",
    enableSorting: false,
  },
  {
    accessorKey: "avg_duration",
    header: "Средняя длительность",
    enableSorting: false,
  },
]

export const OperatorCallTypeReport = ({
  filters,
}: {
  filters: {
    operatorId?: number
    departmentId: number
    startDate?: string
    endDate?: string
  }
}) => {
  const { setPagination, pagination } = useTable({})

  return (
    <div className="p-4 h-full">
      <ReactTailwindTable
        setPagination={setPagination}
        pagination={pagination}
        query={useGetOperatorCallTypeReportQuery}
        queryParams={filters}
        columns={columns}
        visibilityOptions={{
          disablePagination: true,
        }}
      />
    </div>
  )
}
